export default {"src":"/_next/static/image/public/images/flags/flag_213.75052153f95959b487b865bfe0ae5725.svg","height":16,"width":25};